const MobileCardData = [
  {
    title: "Focushub",
    text: "A productivity mobile app designed to help users stay focused and manage their time effectively. Features include task tracking, focus timer, and productivity analytics.",
    view: "#",
    source: "#",
    tools: "Tools Used: React Native, Expo, Firebase, Redux",
    screenshots: [
      require("../../assets/FH1.png"),
      require("../../assets/FH2.png"),
      require("../../assets/FH3.png"),
      require("../../assets/FH4.png"),
      require("../../assets/FH5.png"),
      require("../../assets/FH6.png"),
    ],
  },
  {
    title: "Word Master",
    text: "A React Native mobile game inspired by Wordle with multiple difficulty levels, timer-based gameplay, and statistics tracking. Features include word hints, interactive keyboard, and persistent game stats.",
    view: "https://github.com/zoecabrales/WordleClone/releases/tag/v1.0.3",
    source: "https://github.com/zoecabrales/WordleClone",
    tools: "Tools Used: React Native, Expo, TypeScript, AsyncStorage",
    screenshots: [
      require("../../assets/WM1.jpg"),
      require("../../assets/WM2.jpg"),
      require("../../assets/WM3.jpg"),
      require("../../assets/WM4.jpg"),
      require("../../assets/WM5.jpg"),
    ],
  },
];

export default MobileCardData;
